import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStages(companyId, regulationId) {

	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].getRegulationsStages,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
			},
		},
	)
}
function getRegulationsStagePreview(companyId, regulationId, stageId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].getRegulationsStagePreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
			},
		},
	)
}
function getRegulationsStagePopup(companyId, regulationId, stageId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].getRegulationsStagePopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
			},
		},
	)
}

function createRegulationsStage(companyId, regulationId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].createRegulationsStage, {
		urlParams: {
			companyId,
			regulationId,
		},
		...data,
	})
}

function getRegulationsStage(companyId, regulationId, stageId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].getRegulationsStage, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
		},
	})
}

function patchRegulationsStage(companyId, regulationId, stageId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].patchRegulationsStage, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
		},
		...data,
	})
}

function putRegulationsStage(companyId, regulationId, stageId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].putRegulationsStage, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
		},
		...data,
	})
}

function deleteRegulationsStage(companyId, regulationId, stageId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES,dtConfig[ModulesMap.REGULATIONS_STAGES].deleteRegulationsStage, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
		},
	})
}

export default {
	getRegulationsStages,
	getRegulationsStagePopup,
	getRegulationsStagePreview,
	getRegulationsStage,
	patchRegulationsStage,
	putRegulationsStage,
	createRegulationsStage,
	deleteRegulationsStage,
}
